export default {
  name: "VSIPlatformSection",

  data() {
    return ({
      vsi_data: {
        kicker: "Radical Transparency",
        title: "The VSI Platform",
        description:
          "We don’t guess impact — we track it. The Visible Social Impact Platform is the “Amazon” of impact tracking. Every transaction on a cart’s POS system feeds directly into this dashboard, verifying the SSIN value in real-time.",
        cta_text: "Request Dashboard Access",
        cta_link: "#request-dashboard",
      },

      vsi_metrics: [
        { key: "jobs", label: "Jobs Created", value: "1,245" },
        { key: "assets", label: "Active Assets", value: "312" },
      ],

      vsi_chart: {
        label: "Revenue Generation (Monthly)",
        bars: [
          { key: "m1", height: "18%" },
          { key: "m2", height: "26%" },
          { key: "m3", height: "22%" },
          { key: "m4", height: "38%" },
          { key: "m5", height: "34%" },
          { key: "m6", height: "48%" },
          { key: "m7", height: "42%" },
          { key: "m8", height: "55%" },
          { key: "m9", height: "50%" },
          { key: "m10", height: "62%" },
          { key: "m11", height: "58%" },
          { key: "m12", height: "70%" },
        ],
      },
    });
  },
};
